import type {ReactNode} from 'react';

interface CallToastProps {
    readonly icon: ReactNode;
    readonly lead: string;
    readonly body?: string;
    readonly actionLabel?: string;
    readonly actionTone?: 'neutral' | 'brand';
    readonly testId?: string;
    readonly onAction?: () => void;
}

export const CallToast = ({icon, lead, body, actionLabel, actionTone = 'neutral', testId, onAction}: CallToastProps) => (
    <div
        role="status"
        data-testid={testId}
        className="phq-call-swap pointer-events-auto flex w-full max-w-[640px] items-center gap-3 rounded-xl bg-[var(--phq-call-surface)] py-2.5 pl-3.5 pr-3 text-sm leading-[1.4] shadow-[0_8px_24px_rgba(0,0,0,.4),inset_0_0_0_1px_var(--phq-call-line)]"
    >
        <span className="shrink-0">{icon}</span>
        <p className="min-w-0 flex-1">
            <strong className="font-semibold text-[var(--phq-call-ink)]">{lead}</strong>
            {body && <span className="text-[var(--phq-call-ink-muted)]"> {body}</span>}
        </p>
        {actionLabel && onAction && (
            <button
                type="button"
                onClick={onAction}
                className={`phq-call-press inline-flex h-8 shrink-0 items-center rounded-lg px-3 text-[13px] font-semibold ${actionTone === 'brand' ? 'bg-[var(--phq-call-brand)] text-white' : 'bg-[var(--phq-call-surface-muted)] text-[var(--phq-call-ink)]'}`}
            >
                {actionLabel}
            </button>
        )}
    </div>
);
